module.exports = __webpack_public_path__ + "img/palguin-salto-tres.45d1e01b.jpg";